export const CHECKED_ROWS_ACTION_BAR_BOTTOM = 24;

/** clearance between the snackbar stack and the floating action bar */
export const SNACKBAR_ACTION_BAR_GAP = 12;
